<template>
  <div class="wtw-container clearfix full policies-container">
    <div class="policies-header">
      <h2 class="policies-header-title">Please read and agree to the following to use Mada</h2>
      <checkbox 
        class="policies-header-accept-all"
        label="Accept All"
        name="accept_all"
        color="checked"
        @input="acceptAll"
        :value="allAccepted"
      />
    </div>
    <div class="policies-checkbox-container">
      <checkbox label="Privacy Policy" name="privacy_policy" v-model="accept['privacy-policy']">
        <p class="policies-checkbox-secondary-label">Mada and its affiliates are allowed to process my sensitive personal data to provide services.</p>
        <a class="policies-checkbox-link" @click="open('privacy-policy')">Learn more</a>
      </checkbox>
      <checkbox label="End User License Agreement" name="end_user_license" v-model="accept['end-user-license']">
        <a class="policies-checkbox-link" @click="open('end-user-license')">Learn more</a>
      </checkbox>
      <checkbox label="Terms of Use" name="terms_of_use" v-model="accept['terms-of-use']">
        <a class="policies-checkbox-link" @click="open('terms-of-use')">Learn more</a>
      </checkbox>
    </div>
    <agreement-modal :show="showAgreementModal" :loading="loadingAgreement" :content="modalAgreementHtmlContent" />
  </div>
</template>

<script>
  import Checkbox from "../../common/checkbox.vue";
  import AgreementModal from "./agreements-modal-container.vue";

  export default {
    components: {
      Checkbox,
      AgreementModal,
    },
    props: [
      'label',
      'sendOptions',
    ],
    data: function () {
      return {
        showAgreementModal: false,
        loadingAgreement: false,
        modalAgreementHtmlContent: '',
        accept: {
          'privacy-policy': false,
          'end-user-license': false,
          'terms-of-use': false,
        }
      };
    },
    computed: {
      allAccepted () {
        return Object.keys(this.accept).map(key => this.accept[key]).reduce((acc, value) => acc && value);
      }
    },
    methods: {
      open (agreementType) {
        this.loadingAgreement = true;
        this.showAgreementModal = true;
        this.$parent.$emit('changeChildClass', 'modal-open');
        this.$store.dispatch("onboarding/fetchAgreement", { agreementType })
        .then((agreementContent) => {
          this.loadingAgreement = false;
          this.modalAgreementHtmlContent = agreementContent;
        })
        .catch(() => {
          this.loadingAgreement = false;
          this.modalAgreementHtmlContent = '';
        });
      },
      acceptAll (accepted) {
        Object.keys(this.accept).map(key => this.accept[key] = accepted);
      }
    },
    created () {
      this.$on('closeModal', () => {
          this.showAgreementModal = false;
          this.$parent.$emit('changeChildClass', '');
      });
    },
    watch: {
      sendOptions() {
        this.$parent.$emit('acceptingAgreements', this.allAccepted, this.allAccepted);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './src/var.scss';

  .policies-container {
    .policies-header {
      border-bottom: 1px solid $gray;
      padding: 45px 23px 21px;
      
      :not(:last-child) {
        margin-bottom: 28px;
      }
      .policies-header-title {
				text-align: left;
				font-size: 18px;
        line-height: 24px;
        font-weight: 500;
        max-width: 280px;
    	}
    }
    .policies-checkbox-container {
      margin-top: 20px;
      padding: 0 23px;

      > :not(:last-child) {
        margin-bottom: 16px;
      }
      .policies-checkbox-secondary-label {
        color: $lightDark;
      }
      .policies-checkbox-link {
        color: $pink;
      }
    }
  }
  
</style>